import React from 'react';
import { Nullable } from 'global';
import { NO_DATA } from 'constants/common';
import { Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  subject: Nullable<string>;
  description: Nullable<string>;
}

export const SubjectCell = ({ subject, description }: Props) => (
  <Stack gap="0.25rem" sx={{ minWidth: 0, maxWidth: '16rem' }}>
    <Tooltip title={subject || ''}>
      <Typography variant="body2" fontWeight={600} noWrap>
        {subject || NO_DATA}
      </Typography>
    </Tooltip>

    {description && (
      <Tooltip title={description}>
        <Typography variant="caption" color="text.secondary" noWrap>
          {description}
        </Typography>
      </Tooltip>
    )}
  </Stack>
);
